'use client'

import { cn } from '@/core/lib/utils/cn'
import { dateService } from '@/core/services/date'
import { Divider } from '@heroui/react'
import { useTranslations } from 'next-intl'
import { useOrderSummaryStore } from '../../store'
import { OrderStep } from '../../types/enums/order-step.enum'
import { CircledDivider } from './circled-divider'
import { OrderDiscount } from './discount'
import { EditOrder } from './edit-order'
import { LocationInfo } from './location'
import { OrderPrice } from './order-price'
import { UserDetails } from './user-details'

type Props = {
  className?: string
}
export const OrderSummary: React.FC<Props> = ({ className }) => {
  const t = useTranslations()
  const { date, time, discount, customerPrice, step } = useOrderSummaryStore()
  const isUpdate = useOrderSummaryStore(state => state.isUpdate)
  const canUpdateOrder = step === OrderStep.CREATE_TRIP && !isUpdate
  const hasDiscount = Boolean(discount)

  return (
    <div
      className={cn(
        'bg-grey-5 @container flex w-full flex-col justify-between rounded px-6 py-3',
        className,
      )}
    >
      <div
        className={cn(
          'grid auto-rows-min grid-cols-1 gap-1',
          '@[16rem]:mb-0 @[16rem]:grid-cols-2 @[16rem]:gap-0 @[16rem]:space-y-reverse',
          canUpdateOrder ? 'grid-rows-1' : 'grid-rows-1',
        )}
      >
        <div className='flex flex-col gap-1'>
          <h3 className='text-xl font-medium text-nowrap'>
            {t('trip.orderSummary')}
          </h3>
          {date ? (
            <p className='text-grey w-full font-medium'>
              {dateService.dateToYyMmDd(date)}
            </p>
          ) : null}
          {time ? (
            <p className='text-grey w-full font-medium'>
              {dateService.timeToHM(time)}
            </p>
          ) : null}
        </div>
        {canUpdateOrder ? (
          <EditOrder
            className={
              hasDiscount
                ? 'col-start-1 @[16rem]:row-start-2'
                : 'row-start-3 justify-self-end @[16rem]:col-start-2 @[16rem]:row-start-1'
            }
          />
        ) : null}
        {hasDiscount ? (
          <OrderDiscount
            className={cn(
              !!customerPrice && '!col-start-1 !row-start-3 row-end-3',
              !customerPrice &&
                'col-start-1 row-start-2 items-start @[16rem]:col-start-2 @[16rem]:row-start-1 @[16rem]:items-end @[16rem]:justify-self-end',
            )}
          />
        ) : null}
      </div>
      <div className='my-1'></div>
      <UserDetails />
      <Divider />
      <LocationInfo />
      <CircledDivider />
      <OrderPrice />
    </div>
  )
}
